export const USER_COMPANY_METADATA = {
  LTL: "ltl",
  ASSET_LTL: "assetLTL",
  BROKERAGE_LTL: "brokerageLTL",
  COMPANY_NAME: "companyName"
};
